import type { SearchableComboboxOption } from "@/components/ui/searchable-combobox"

export type CatalogModelOptionSource = {
  id: string
  label: string
  enabled?: boolean
  platform_disabled?: boolean
}

export function catalogModelComboboxOption(
  model: CatalogModelOptionSource,
  platformDisabledLabel: string,
): SearchableComboboxOption {
  return {
    value: model.id,
    label: model.label,
    disabled: model.enabled === false,
    disabledHint: model.platform_disabled ? platformDisabledLabel : undefined,
  }
}

/** Опции меню моделей: сначала доступные, внутри — по подписи. */
export function sortedCatalogModelOptions(
  models: ReadonlyArray<CatalogModelOptionSource>,
  platformDisabledLabel: string,
): SearchableComboboxOption[] {
  return [...models]
    .sort((a, b) => {
      const aEnabled = a.enabled !== false
      const bEnabled = b.enabled !== false
      if (aEnabled !== bEnabled) return aEnabled ? -1 : 1
      return a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    })
    .map((model) => catalogModelComboboxOption(model, platformDisabledLabel))
}
